import React, { useEffect } from 'react';

interface AlertNotificationProps {
  type: 'success' | 'error';
  message: string;
  onClose: () => void;
}

const AlertNotification: React.FC<AlertNotificationProps> = ({ type, message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`notification ${type}`}>
      <span>{message}</span>
      <button className="close-btn" onClick={onClose}>×</button>
    </div>
  );
};

export default AlertNotification;
